import { render, staticRenderFns } from "./AddNewPositionModal.vue?vue&type=template&id=008d4e8c&scoped=true&"
import script from "./AddNewPositionModal.vue?vue&type=script&lang=js&"
export * from "./AddNewPositionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNewPositionModal.vue?vue&type=style&index=0&id=008d4e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008d4e8c",
  null
  
)

export default component.exports